import { toGlobalId } from 'graphql-relay';
import uuid from 'uuid';
import User from 'helper/currentUser';

import { CourseCompletionOrderEnum } from '../../graphql/gqlTypes/transformToEnums/CourseCompletionOrderEnum';
import { CardCompletionTypeEnum } from '../../graphql/gqlTypes/transformToEnums/CardCompletionTypeEnum';

const user = new User();

const getCards = cards => {
  const edges = cards.map(card => {
    let questionAnswers = [];
    let questionsForReview = [];
    const offerType = card.offerType;
    if (offerType === 'peerReviewCard') {
      questionsForReview = card.children;
      questionsForReview = questionsForReview.map(questionForReview => ({
        ...questionForReview,
        _id: questionForReview._id || card._id,
        states: []
      }));
    } else if (offerType === 'assignmentCard') {
      questionAnswers = card.children;
      questionAnswers = questionAnswers.map(questionAnswer => ({
        ...questionAnswer,
        _id: questionAnswer._id || card._id,
        states: [],
        stateInteractions: []
      }));
    }
    const rawData = {};
    let maxScore = 0;
    if (card.maxScore !== null && card.maxScore !== undefined) {
      maxScore = card.maxScore;
    }
    if (offerType === 'assignmentCard') {
      maxScore = card.children.reduce((a, b) => {
        const childMaxScore = b.maxScore;
        return childMaxScore ? a + childMaxScore : a;
      }, 0);
    }
    if (card.content.subType === 'objective') {
      rawData.card = { ...card };
      const transformedChildrens = card.children.map(cardQuestion => {
        const cardState = {
          submissions: [
            {
              _id: uuid(),
              rawScore: 0,
              gradedBy: null,
              progressMeasure: 0,
              response: '',
              answerEvaluation: '',
              responseType: '',
              submittedOn: new Date('1000-01-01T00:00:00Z').toISOString(),
              reviewsReceivedCount: 0
            }
          ],
          reAttemptCount: 0,
          actualSubmit: false
        };
        return {
          cardQuestion,
          state: cardState
        };
      });
      rawData.card.children = transformedChildrens;
      rawData.state = {};
    }
    const node = {
      completionType: CardCompletionTypeEnum[card.completionType],
      ...card.content,
      id: toGlobalId('', card._id),
      isGradable: card.isGradable,
      pid: card._id,
      type: card.content.contentType,
      resource: card,
      questionAnswers,
      questionsForReview,
      maxScore,
      performance: null,
      rawData: JSON.stringify(rawData)
    };
    return node;
  });
  return edges;
};

const getSections = children => {
  const edges = children.map((section, index) => {
    const cards = getCards(section.children);
    const node = {
      id: toGlobalId('', section._id),
      name: section.content && section.content.name,
      pid: section._id,
      position: index + 1,
      cards
    };
    return node;
  });
  return { sections: edges };
};

const getTransformedFields = offer => {
  let previewOffer = {};
  const children = offer.children || [];
  const totalCards = children.reduce(
    (accumulator, currentItem) => accumulator + (currentItem.children || []).length,
    0
  );
  let orderOfCompletion = offer.orderOfCompletion;
  if (!orderOfCompletion) {
    orderOfCompletion = CourseCompletionOrderEnum.anyOrder;
  } else {
    orderOfCompletion = CourseCompletionOrderEnum[orderOfCompletion];
  }
  const isGradable = !!(
    offer.successStatusRollupRules && offer.successStatusRollupRules.length > 0
  );
  const sections = getSections(children);
  const fields = {
    ...offer,
    assignInfo: null,
    user: {
      id: toGlobalId('User', user.id().toString()),
      pid: user.id()
    },
    companyId: offer.content.companyId,
    name: offer.content.name,
    description: offer.content.description,
    duration: offer.content.duration,
    image: offer.content.picture,
    deactivateFrom: '',
    isGradable,
    orderOfCompletion,
    coursePerformance: null,
    totalCards,
    teachers: [],
    prerequisites: []
  };
  previewOffer = { ...fields, ...sections };
  return previewOffer;
};

export default getTransformedFields;
